import { useEffect } from 'react';
import { clsx } from 'clsx';
import { useNavigate } from 'react-router-dom';
import { oceanLogoOnBlue } from '@/assets/images/offer/tiers';
import { routes } from '@/routes/routes';
import { useAnafWaitProgress } from '../../hooks/useAnafWaitProgress';
import { useOfferRequest } from '../../hooks';
import { VoltAppBanner } from '../../components/VoltAppBanner';
import styles from './AnafInProgressPage.module.scss';

const POLL_MS = 15_000;
// Lets the bar fill before the next screen.
const FINISH_MS = 400;

export function AnafInProgressPage() {
  const navigate = useNavigate();
  const { offer, requestOffer } = useOfferRequest();
  const { progress, finish } = useAnafWaitProgress();

  useEffect(() => {
    requestOffer();

    const intervalId = setInterval(() => {
      requestOffer();
    }, POLL_MS);

    return () => clearInterval(intervalId);
  }, []);

  const nextRoute =
    offer?.status === 'NoOfferAvailable'
      ? routes.offer.notAvailable
      : offer?.status === 'Complete'
        ? routes.application.base
        : null;
  useEffect(() => {
    if (!nextRoute) {
      return;
    }

    finish();
    const timer = setTimeout(() => navigate(nextRoute), FINISH_MS);
    return () => clearTimeout(timer);
  }, [nextRoute]);

  return (
    <div className={styles.root}>
      <div className={styles.cardWrapper} aria-hidden>
        <div className={styles.cardGlow} />
        <div className={styles.card}>
          <div className={styles.cardOverlay} />
          <div className={styles.cardRow}>
            <img
              src={oceanLogoOnBlue}
              alt=""
              width={120}
              height={15}
              className={styles.logo}
            />
            <div className={clsx(styles.skeleton, styles.skeletonBadge)} />
          </div>
          <div className={styles.cardRow}>
            <div className={styles.skeletonGroup}>
              <div className={clsx(styles.skeleton, styles.skeletonLabel)} />
              <div className={clsx(styles.skeleton, styles.skeletonAmount)} />
            </div>
            <div className={clsx(styles.skeleton, styles.skeletonAside)} />
          </div>
        </div>
      </div>

      <div className={styles.status}>
        <div className={styles.text}>
          <h1 className={styles.title}>
            Îți pregătim
            <br />
            oferta finală
          </h1>
          <p className={styles.description}>
            Verificăm veniturile tale la ANAF. De obicei, durează câteva minute.
          </p>
        </div>
        <div
          className={styles.progress}
          role="progressbar"
          aria-label="Verificarea veniturilor la ANAF"
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuenow={Math.round(progress * 100)}
        >
          <div
            className={styles.progressFill}
            style={{ transform: `translateX(${(progress - 1) * 100}%)` }}
          />
        </div>
      </div>

      <VoltAppBanner
        title={
          <>
            Durează prea mult?
            <br />
            Continuă în Volt.
          </>
        }
        trackingId="anaf_wait_download_volt"
      />
    </div>
  );
}
